import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { UserService } from '@app/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class AdminGuard  {
  private readonly _componentName = 'AdminGuard';
  
  constructor(readonly userService: UserService, readonly router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.userService.isLoggedIn && this.userService.isAdmin) {
      return true;
    }

    return false;
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.userService.isLoggedIn && this.userService.isAdmin) {
      return true;
    }

    return false;
  }
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    if (this.userService.isLoggedIn && this.userService.isAdmin) {
      return true;
    }

    return false;
  }
}
